import { render, staticRenderFns } from "./birthdayGiftDialogNew.vue?vue&type=template&id=3b363c86&scoped=true"
import script from "./birthdayGiftDialogNew.vue?vue&type=script&lang=js"
export * from "./birthdayGiftDialogNew.vue?vue&type=script&lang=js"
import style0 from "./birthdayGiftDialogNew.vue?vue&type=style&index=0&id=3b363c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b363c86",
  null
  
)

export default component.exports